(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyManagementDeleteController',PartyManagementDeleteController);

    PartyManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'PartyManagement'];

    function PartyManagementDeleteController($uibModalInstance, entity, PartyManagement) {
        var vm = this;

        vm.party = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PartyManagement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
